<div class="subheader with-padding flgrow">
  <div class="row">
    <div class="col-sm-3">
      <div class="relative flmid">
        <div class="flgrow">
          <div class="input-group">
            <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearch' | translate }}"
            [(ngModel)]="pService.searchTerm" autocomplete="off" />
            <div class="input-group-append">
              <button type="button" class="btn btn-primary">
                <em class="fa fa-search"></em>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-2 pl-4"  *ngIf="dealerList && dealerList.length > 0;">
      <div class="flmid">
        <div class="flgrow ">
          <ng-container>
            <app-dealer-searchbox-dropdown class="" [dealerList]="dealerList" [selectedDealer]="dealerId"
            ngDefaultControl name="dealerDropdown"
              (onSelectDealer)="onDealerSelected($event)"
              placeholder="{{ 'lblSearchDealer' | translate }}">
            </app-dealer-searchbox-dropdown>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="col-auto ml-auto" *ngIf="userRoleRightsDetails.canAdd">
      <button type="button" (click)="onAdd()" aria-label="Center Align" type="reset" class="add-button btn btn-primary"
        translate>lblAddDealerHoliday</button>
    </div>
  </div>
</div>
<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <div class="card-header d-flex">
          <h4 class="card-title" translate>lblNationalHolidays</h4>

        </div>
        <div class="table-responsive ">
          <table class="tablest1">
            <thead>
              <tr>
                <th style="width:55px" scope="col">#</th>
                <th scope="col" sortable="name" (sort)="onSort($event)" translate>lblName</th>
                <th scope="col" sortable="dealerName" (sort)="onSort($event)" translate>lblDealerName</th>
                <th scope="col" translate>lblStartDate</th>
                <th scope="col" translate>lblEndDate</th>
                <th style="width:120px" class="text-center" scope="col" translate>lblAction</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="dealerHolidayList?.length>0; else load_else">
                <tr *ngFor="let dealerHoliday of dealerHolidayList; let i=index">
                  <td>{{ dealerHoliday.rowNumber }}</td>
                  <td>
                    <ngb-highlight [result]="dealerHoliday.name" [term]="pService.searchTerm"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="dealerHoliday.dealerName" [term]="pService.searchTerm">
                    </ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight result="{{dealerHoliday.startDate}}" [term]="pService.searchTerm">
                    </ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight  result="{{dealerHoliday.endDate}}" [term]="pService.searchTerm">
                    </ngb-highlight>
                  </td>
                  <td class="nowrap text-center">

                    <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert"
                      *ngIf="userRoleRightsDetails.canEdit" 
                      (click)="editDealerHoliday(dealerHoliday.id)">
                      <em class="fas fa-pencil-alt fa-lg"></em>
                    </a>
                    <span class="ico-div" *ngIf="userRoleRightsDetails.canDelete"></span>
                    <a class="btn btn-ico" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert"
                      *ngIf="userRoleRightsDetails.canDelete" 
                      (click)="deleteDealerHoliday(dealerHoliday.id)">
                      <em class="far fa-trash-alt fa-lg"></em>
                    </a>


                  </td>
                </tr>
              </ng-container>
              <ng-template #load_else>
                <tr>
                  <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
        <div class="card-footer">
          <div class="d-flex justify-content-between">
            <div class="d-flex justify-content-between">
              <ngb-pagination [collectionSize]="pService.total$  | async" [(page)]="pService.page"
                [pageSize]="pService.pageSize" [maxSize]="3">
              </ngb-pagination>
              <select class="custom-select mx-2" style="width: auto" name="pageSize" [(ngModel)]="pService.pageSize">
                <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>{{item.label}}
                </option>
              </select>
            </div>
            <div class="d-flex justify-content-between p-2 font17 fontbold" style="margin: auto 0;">
              <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{pService.total$ | async}}&nbsp;<span class="font17 fontnormal" translate>lblResults</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>